
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.2 27.6L.3 18l2.6-2.7 7.3 7.2L29.1 4.4l2.6 2.7z"}})])
          )
        }
      }
    